import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon, AlertCircleIcon, InfoIcon } from 'lucide-react';
interface ToastProps {
  type: 'success' | 'error' | 'info' | 'warning';
  message: string;
  duration?: number;
  onClose: () => void;
  isVisible: boolean;
}
export function Toast({
  type = 'info',
  message,
  duration = 5000,
  onClose,
  isVisible
}: ToastProps) {
  const [isClosing, setIsClosing] = useState(false);
  useEffect(() => {
    if (isVisible && duration > 0) {
      const timer = setTimeout(() => {
        setIsClosing(true);
        setTimeout(() => {
          onClose();
          setIsClosing(false);
        }, 300); // Animation duration
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [isVisible, duration, onClose]);
  if (!isVisible) return null;
  const typeStyles = {
    success: 'bg-green-50 border-green-200 text-green-800',
    error: 'bg-red-50 border-red-200 text-red-800',
    warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
    info: 'bg-blue-50 border-blue-200 text-blue-800'
  };
  const iconStyles = {
    success: 'text-green-500',
    error: 'text-red-500',
    warning: 'text-yellow-500',
    info: 'text-blue-500'
  };
  const Icon = () => {
    switch (type) {
      case 'success':
        return <CheckCircleIcon className={`h-5 w-5 ${iconStyles[type]}`} data-id="element-1235" />;
      case 'error':
        return <AlertCircleIcon className={`h-5 w-5 ${iconStyles[type]}`} data-id="element-1236" />;
      case 'warning':
        return <AlertCircleIcon className={`h-5 w-5 ${iconStyles[type]}`} data-id="element-1237" />;
      case 'info':
      default:
        return <InfoIcon className={`h-5 w-5 ${iconStyles[type]}`} data-id="element-1238" />;
    }
  };
  return <div className={`fixed top-4 right-4 z-50 max-w-md transform transition-all duration-300 ease-in-out ${isClosing ? 'translate-x-full opacity-0' : 'translate-x-0 opacity-100'}`} data-id="element-1239">
      <div className={`rounded-lg border p-4 shadow-lg ${typeStyles[type]}`} data-id="element-1240">
        <div className="flex items-start" data-id="element-1241">
          <div className="flex-shrink-0" data-id="element-1242">
            <Icon data-id="element-1243" />
          </div>
          <div className="ml-3 flex-1" data-id="element-1244">
            <p className="text-sm font-medium" data-id="element-1245">{message}</p>
          </div>
          <div className="ml-4 flex-shrink-0 flex" data-id="element-1246">
            <button type="button" className={`inline-flex rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 ${iconStyles[type]}`} onClick={() => {
            setIsClosing(true);
            setTimeout(() => {
              onClose();
              setIsClosing(false);
            }, 300);
          }} data-id="element-1247">
              <span className="sr-only" data-id="element-1248">Close</span>
              <XIcon className="h-5 w-5" data-id="element-1249" />
            </button>
          </div>
        </div>
      </div>
    </div>;
}